import { render, staticRenderFns } from "./Snimani.vue?vue&type=template&id=c93dce80&scoped=true&"
import script from "./Snimani.vue?vue&type=script&lang=ts&"
export * from "./Snimani.vue?vue&type=script&lang=ts&"
import style0 from "./Snimani.vue?vue&type=style&index=0&id=c93dce80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93dce80",
  null
  
)

export default component.exports